
//此文件用于存储全局公用配置
export default class BaseConfig{
    constructor(){}
    static webSocketPrefix = function() {
        return localStorage.getItem('$socketUrl') || '';
    };
    static P_TITLE='公共机构节能监管平台';
    //总览页path
    static MAIN_INDEX_PATH = "dashboard";
    // static MAIN_INDEX_PATH = "index";
      //loading对象实体
    static loading = {
        text: '拼命加载中',
        spinner: 'el-icon-loading',
        background: 'rgba(240,248,255, 0.5)',
    };
    //分页-每页数量
    static PAGE_SIZE = 15;
//分页size list
    static PAGE_SIZE_LIST = [
        {
            label: "10 条/页",
            value: 10,
        },
        {
            label: "15 条/页",
            value: 15,
        },
        {
            label: "20 条/页",
            value: 20,
        },
        {
            label: "50 条/页",
            value: 50
        },
        {
            label: "100 条/页",
            value: 100
        },
        {
            label: "200 条/页",
            value: 200
        },
    ];
    //手机正则
    static MOBILE_REGEXP = /^1([3578][0-9]|4[579]|66|7[0135678]|9[89])[0-9]{8}$/;
    //邮箱正则
    static EMAIL_REGEXP = /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/;
    static messageDuration = 2000;
    static imgLimitSize = 10; //限制上传图片文件大小，单位M
    // static DESIGNER_URL = process.env.DESIGNER_URL;
    static centrallyDeployed = true; //项目是否集中部署
    static pointDisabledTitle = '禁用点位';
}
